import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { FadeIn } from './FadeIn';
const ParallaxImage = ({
  src,
  aspect,
  delay,
  yRange
}: {
  src: string;
  aspect: string;
  delay: number;
  yRange: string[];
}) => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], yRange);
  return <FadeIn delay={delay} className="h-full" data-id="element-77">
      <div ref={ref} className={`group relative overflow-hidden ${aspect} h-full`} data-id="element-78">
        <motion.img src={src} alt="Code 11 wedding" className="w-full h-[120%] object-cover origin-center transition-transform duration-1000 group-hover:scale-105" style={{
        y
      }} data-id="element-79" />
        <div className="absolute inset-0 bg-copper/15 opacity-0 group-hover:opacity-100 transition-opacity duration-700 mix-blend-overlay" data-id="element-80" />
      </div>
    </FadeIn>;
};
export function Gallery() {
  return <section id="gallery" className="py-32 md:py-44 bg-cream overflow-hidden" data-id="element-81">
      <div className="container mx-auto px-6 md:px-12" data-id="element-82">
        <FadeIn data-id="element-83">
          <div className="mb-16 text-center" data-id="element-84">
            <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs block" data-id="element-85">
              Gallery
            </span>
          </div>
        </FadeIn>

        <div className="flex flex-col gap-4 md:gap-6" data-id="element-86">
          {/* Row 1: Large + Tall */}
          <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-87">
            <div className="w-full md:w-2/3" data-id="element-88">
              <ParallaxImage src="https://code-11.hr/wp-content/uploads/elementor/thumbs/IMG_5539-rid7af187ywc80yrzwng55cg0yrwvusu5sq10hjvvs.png" aspect="aspect-[16/10]" delay={0} yRange={['-8%', '8%']} data-id="element-89" />
            </div>
            <div className="w-full md:w-1/3" data-id="element-90">
              <ParallaxImage src="https://code-11.hr/wp-content/uploads/2026/01/c73a57a6-e079-441f-9046-d90dc61de4e6-scaled.jpg" aspect="aspect-[3/4]" delay={0.15} yRange={['-12%', '12%']} data-id="element-91" />
            </div>
          </div>

          {/* Row 2: Three equal columns */}
          <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-92">
            <div className="w-full md:w-1/3" data-id="element-93">
              <ParallaxImage src="https://code-11.hr/wp-content/uploads/2025/05/2G6A8588-scaled.jpg" aspect="aspect-square" delay={0.1} yRange={['-6%', '14%']} data-id="element-94" />
            </div>
            <div className="w-full md:w-1/3" data-id="element-95">
              <ParallaxImage src="https://code-11.hr/wp-content/uploads/2025/05/2G6A7666-scaled.jpg" aspect="aspect-square" delay={0.2} yRange={['-14%', '6%']} data-id="element-96" />
            </div>
            <div className="w-full md:w-1/3" data-id="element-97">
              <ParallaxImage src="https://code-11.hr/wp-content/uploads/2026/01/IMG_5540.png" aspect="aspect-square" delay={0.3} yRange={['-10%', '10%']} data-id="element-98" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}